module.exports = __webpack_public_path__ + "media/images/svg-icon/tables-d616a5790099891e400778a284a73c78.svg";